import { AdUnitTypeResponse } from '@hprofits/api';
import { dictionaryKeys, type FullFlatMode, useAdUnitTypes } from '@hprofits/api-client';
import { hasValue } from '@hprofits/utils/fp/optional';
import { useQueryClient } from '@tanstack/vue-query';
import { computed } from 'vue';

import { apiClient } from '@/api-client';
import { DataSource } from '@/modules/common/state/types';
import { useQueryDataSource } from '@/modules/common/state/useQueryDataSource';

export type AdUnitTypes = Readonly<{
  adUnits: AdUnitTypeResponse;
}>;

export const useAdUnitTypesDataSource = (mode: FullFlatMode): DataSource<AdUnitTypes> => {
  const queryClient = useQueryClient();
  const { data, isLoading, error } = useAdUnitTypes(apiClient, mode);

  const invalidate = () => {
    return queryClient.invalidateQueries({
      queryKey: dictionaryKeys.adUnitTypes(mode),
    });
  };

  const adUnits = computed(() => {
    const adUnits = data.value;
    return hasValue(adUnits) ? { adUnits } : undefined; // TODO: Is it OK using `undefined` for Ref?
  });

  return useQueryDataSource({
    query: {
      data: adUnits,
      isLoading,
      error,
      refetch: invalidate,
    },
  });
};
